import { Directive, ElementRef, Input, Renderer2, RendererStyleFlags2 } from '@angular/core';

import type { SupportedThemes, Theme } from '@recruitee/theme';
import { tokenToCssVar } from '@recruitee/utils';

type IconSpecificTokenExtract<T> = Extract<T, `colorIcon${string}` | `misc${string}`>;
type ExtractedIconToken = IconSpecificTokenExtract<keyof Theme>;

export type IconToken = ExtractedIconToken extends never
  ? IconSpecificTokenExtract<keyof typeof SupportedThemes.light>
  : ExtractedIconToken;

@Directive({
  selector: '[iconColor]',
  exportAs: 'iconColor',
  standalone: true,
})
export class IconColorDirective {
  @Input('iconColor') public set colorToken(value: IconToken | undefined) {
    const colorToken = value || 'colorIconDefault';
    this.renderer.addClass(this.elementRef.nativeElement, 'icon-color-token');
    this.renderer.setStyle(
      this.elementRef.nativeElement,
      '--icon-color-token',
      tokenToCssVar(colorToken),
      RendererStyleFlags2.Important + RendererStyleFlags2.DashCase,
    );
  }

  constructor(
    public elementRef: ElementRef,
    private renderer: Renderer2,
  ) {}
}
